import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader
import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import { mask } from 'vue-the-mask'  // Does not seem to be imported as needed...double check

Vue.use(Vuetify)

export default new Vuetify({
  directives: {
    mask
  },
  icons: {
    iconfont: 'mdi', // default - only for display purposes
  },
  theme: {
    dark: false,
    themes: {
      light: {
        primary: '#0072CE',
        secondary: '#707372',
        accent: '#40C1AC',
        error: '#D22630',
        info: '#9E007E',
        success: '#0cba00',
        warning: '#EAAA00'
      },
      dark: {
        primary: '#0072CE',
        secondary: '#707372',
        accent: '#40C1AC',
        error: '#D22630',
        info: '#9E007E',
        success: '#0cba00',
        warning: '#EAAA00'
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/plugins/vuetify.js